import { PaymentTypes } from '../../types';

const initialState = {
  initialDate: undefined,
  lastDate: undefined
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PaymentTypes.SAVE_CURRENT_MONTH:
      return { ...state, ...payload };
    default:
      return state;
  }
};
